import { createSelector } from 'reselect';
import { studySpoPracticeSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const studySpoPracticeYearsSelector = createSelector(studySpoPracticeSelector, (studySpoPractice) =>
  extractDatesFromNestedItems(studySpoPractice?.content, [
    {
      type: 'range',
      startField: 'startAt',
      endField: 'endAt',
    },
  ]),
);
